<template>
  <div class="menu-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right"
             @submit.native.prevent>
      <div style="max-width: 722px;">
        <el-form-item label-width="70px" label="菜单编号：">
          <el-input class="zwx-input" v-model="mainForm.menuNoticeLike" placeholder="请输入"
                    @keyup.enter.native="search(1)" clearable/>
        </el-form-item>
        <el-form-item label-width="70px" label="菜单标题：">
          <el-input class="zwx-input" v-model="mainForm.menuTitleLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="42px" label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider"/>
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询
      </el-button>
      <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()"
                 v-if="$validate.checkbtns(btns[0])">添加
      </el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="menuNotice" label="菜单编号" :width="$system.calWidth(dataList, 'menuNotice', '菜单编号')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column label="菜单标题" :width="$system.calWidth(dataList, 'menuTitle', '菜单标题', '\xa0\xa0\xa0\xa0\xa0\xa0')"
                       header-align="left" align="left">
        <template slot-scope="scope">
          <template v-for="item in scope.row.menuNotice.split('.').length - 1" :row-key="item">{{
              '\xa0\xa0\xa0'
            }}
          </template>
          <template>{{ scope.row.menuTitle }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="menuCode" label="菜单编码" :width="$system.calWidth(dataList, 'menuCode', '菜单编码')"
                       header-align="center" align="center"></el-table-column>
      <el-table-column label="菜单类别" width="86" header-align="center" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.menuType === 0">目录</template>
          <template v-if="scope.row.menuType === 1">内部菜单</template>
          <template v-else-if="scope.row.menuType === 2">外部菜单</template>
        </template>
      </el-table-column>
      <el-table-column label="菜单URL" :width="$system.calWidth(dataList, 'menuUrl', '菜单URL')" header-align="left"
                       align="left">
        <template slot-scope="scope">
          <template v-if="scope.row.menuType === 0">{{ '' }}</template>
          <template v-else>{{ scope.row.menuUrl }}</template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作"
                       :min-width="$system.calMinWidth({ wordNum: 14, arrowNum: 3, btnNum: 6 })" header-align="left"
                       align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="detail(scope.row)">查看
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="edit(scope.row)" v-if="$validate.checkbtns(btns[0])">编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="btn(scope.row)" v-if="scope.row.menuType !== 0">功能按钮维护
          </el-button>
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
                     v-if="$validate.checkbtns(btns[0])">{{ scope.row.ifEnable ? '停用' : '启用' }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="!scope.row.ifEnable && $validate.checkbtns(btns[0])">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange"/>
  </div>
</template>

<script>
export default {
  name: 'MenuManage',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      btns: ['e96660be58dfbf6c'],
      mainForm: {
        menuTitleLike: '',
        menuNoticeLike: '',
        ifEnables: [true],
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {
  },
  mounted() {
    this.search(this.currentPage)
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage)
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        currentPage: this.currentPage,
        menuTitleLike: this.mainForm.menuTitleLike,
        menuNoticeLike: this.mainForm.menuNoticeLike,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null,
      }
      this.$system.get(this.api + '/systematic/getMenuList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.menuList
        this.total = data.menuCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid, ifEnable: !row.ifEnable}
      this.$system.post(this.api + '/systematic/modifyMenuState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid}
      this.$system.post(this.api + '/systematic/deleteMenu-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    add() {
      this.$router.push({name: 'MenuEdit', params: {}})
    },
    edit(row) {
      this.$router.push({name: 'MenuEdit', params: {rid: row.rid}})
    },
    detail(row) {
      this.$router.push({name: 'MenuDetail', params: {rid: row.rid}})
    },
    btn(row) {
      this.$router.push({name: 'MenuBtn', params: {rid: row.rid, menuTitle: row.menuTitle}})
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
